import {useState} from 'react';
import GoBackHeader from "../components/GoBackHeader.tsx";
import {Loader2} from "lucide-react";
import {useLocation} from "react-router-dom";

const GoogleMap = () => {
    const [isLoading, setIsLoading] = useState(true);
    const { state } = useLocation();
    const { mapLink } = state;

    return (
        <div>
            <GoBackHeader/>
            {isLoading && (
                <div className="absolute inset-0 flex flex-col gap-4 items-center justify-center bg-gray-50">
                    <div><Loader2 className="size-16 text-blue-500 animate-spin" /></div>
                    <p className="ml-2 text-gray-600">Chargement de la page en cours ...</p>
                </div>
            )}
            <iframe
                src={mapLink}
                className="w-full h-full border-0"
                allowFullScreen
                title="Embedded Page"
                onLoad={() => setIsLoading(false)}
            />
        </div>
    );
};

export default GoogleMap;
